import React from "react";
import { Card, Form } from "react-bootstrap";
import FormatResourceStatus from "../../../../../../../../../components/Common/Formatters/FormatResourceStatus/FormatResourceStatus";

interface Props {
	id: string;
	label: string;
	badgeStatus?: string;
	description: string;
	checked: boolean;
	content?: JSX.Element;
	onClick: () => void;
}

const ProformaPreviewPaymentMethodCard = ({
	id,
	label,
	badgeStatus,
	description,
	checked,
	content,
	onClick,
}: Props) => {
	return (
		<Card className={`proforma-preview-payment-method-card ${checked && "border-primary"}`}>
			<label aria-label={id}>
				<Card.Body>
					<div className="d-flex align-items-start">
						<Form.Check
							name={id}
							label={label}
							type="radio"
							className="form-check"
							checked={checked}
							id={id}
							onClick={onClick}
						/>
						{badgeStatus && <FormatResourceStatus status={badgeStatus} className="ms-2 mt-1" />}
					</div>
					<div className="description">
						<span className="text-muted">
							{description}
							{content}
						</span>
					</div>
				</Card.Body>
			</label>
		</Card>
	);
};

export default ProformaPreviewPaymentMethodCard;
